import * as React from "react";
import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";
import { TableCell, TableRow } from "@/components/ui/table";

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title = "No results",
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2 py-12 text-center",
        className
      )}
    >
      <div className="rounded-full bg-muted p-3 text-muted-foreground">
        {icon ?? <Inbox className="h-5 w-5" />}
      </div>
      <p className="text-sm font-medium">{title}</p>
      {description && (
        <p className="text-sm text-muted-foreground">{description}</p>
      )}
      {action}
    </div>
  );
}

export interface EmptyTableRowProps {
  colSpan: number;
  title?: string;
  description?: string;
  className?: string;
}

export function EmptyTableRow({
  colSpan,
  title = "No results.",
  description,
  className,
}: EmptyTableRowProps) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className={cn("h-24 text-center", className)}>
        {description ? (
          <EmptyState title={title} description={description} className="py-0" />
        ) : (
          <span className="text-muted-foreground">{title}</span>
        )}
      </TableCell>
    </TableRow>
  );
}
